import { createAPI, decryptUrl } from '../../common'
import qs from 'qs'
/**
 * 对api请求进行二次封装，注意：因在打包后会对url进行加密处理在该方法内请勿直接操作url，如需操作可引用common中decryptUrl先进行解密再操作
 * @param url
 * @param method
 * @param config
 * @param vconfig
 * @returns {*}
 */
const requestCommonAPI = (url, method, config = {}, vconfig = {}) => {
  // 对url进行解密
  url = decryptUrl(url)
  let CONFIG = {
    ...config,
    headers: {
      ...config.headers,
      MediaxMod:
        config.headers && config.headers.MediaxMod
          ? config.headers.MediaxMod
          : 'mbd-special'
    }
  }
  return createAPI(url, method, CONFIG, vconfig)
}
const formatApiRequest = function (url, action, config = {}, vconfig) {
  config = {
    ...config,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...config.headers
    }
  }
  if (config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
    config.data = qs.stringify(config.data)
  }
  return requestCommonAPI(url, action, config, vconfig)
}
export default {
  // 新建修改专题分组
  saveSpecialGroup: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0hspvq0tbwf',
      'get',
      config,
      vconfig
    ),
  // 获取全部专题分组
  getSpecialGroupAll: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0hspvq0tfbsdi',
      'post',
      config,
      vconfig
    ),
  // 获取专题的创建人
  getSpecialCreators: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0f6vtfs0mjtu',
      'get',
      config,
      vconfig
    ),
  // 专题分组排序
  putSpecialGroupSort: (config) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0hspvq0tpsu',
      'put',
      config
    ),
  // 获取全部专题分组
  getMainTableListDate: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0mjtu',
      'post',
      config,
      vconfig
    ),
  // 新建/修改专题
  saveSpecial: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0tbwf',
      'post',
      config,
      vconfig
    ),
  // 删除专题
  deleteSpecial: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0efmfuf',
      'post',
      config,
      vconfig
    ),
  // 移动专题
  moveSpecials: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0npwf',
      'post',
      config,
      vconfig
    ),
  // 查询符合条件的加稿稿件列表
  getArticleList: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.gut0nfejbyGut0mjtu', 'post', config, vconfig),
  // 根据关键字查询专题分组
  getSpecialGroupByKeyword: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0hspvq0tfbsdi',
      'post',
      config,
      vconfig
    ),
  // 获取流程记录接口
  getSpecialLogs: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0f60bdujpot0mpht',
      'get',
      config,
      vconfig
    ),
  // 获取当前专题的操作权限
  getSelectionActions: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0f60bdujpot',
      'get',
      config,
      vconfig
    ),
  // 专题加稿--图片库预览功能--获取稿件详情
  getArticleDetail: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.jnbhf0qipup0efubjm', 'get', config, vconfig),
  // 专题加稿--新华社稿库预览功能--获取稿件详情
  getXinHuaArticleDetail: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.xjsf0bsujdmf0efubjm', 'get', config, vconfig),
  // 专题加稿--新华社图库预览功能--获取稿件详情
  getXinHuaPicDetail: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.xjsf0qipup0efubjm', 'get', config, vconfig),
  // 专题加稿--新媒体成品库预览功能--获取稿件详情
  getNewMediaDetail: (config, vconfig) =>
    formatApiRequest('/mediax-mbd/api/fts/document', 'post', config, vconfig),
  // 专题手动加锁接口
  rcSpecialPreAction: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0f60bdujpot0qsfbdujpo',
      'get',
      config,
      vconfig
    ),
  // 专题手动解锁接口
  rcSpecialPostAction: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0f60bdujpot0qptubdujpo',
      'get',
      config,
      vconfig
    ),
  // 新建修改专题稿件: 专题加稿--多张
  saveSpecialArticle: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0bsujdmf0cbudi0tbwf',
      'post',
      config,
      vconfig
    ),
  // 获取专题稿件列表
  getArticlesInThisSpecial: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0bsujdmf0mjtu',
      'post',
      config,
      vconfig
    ),
  // 专题定制条件接口
  setSpecialCondition: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0dvtupnj{fe0dpoejujpo',
      'post',
      config,
      vconfig
    ),
  // 专题定制条件接口
  updateSpecialData: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0dvtupnj{fe0dpoejujpo0gut0ebub',
      'post',
      config,
      vconfig
    ),
  // 点击弹窗按钮解锁
  postE5Unlocker: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0f60bdujpot0vompdlfs',
      'post',
      config,
      vconfig
    ),
  // 获取数据位置配置
  getDataLocationConfig: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0bsujdmf0ebub0mpdbujpo0dpogjh',
      'post',
      config,
      vconfig
    ),
  // 移除专题中稿件的接口
  deleteArticlesInSpecial: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0bsujdmf0efmfuf',
      'post',
      config,
      vconfig
    ),
  // 专题稿件批量下载
  downloadSpecialArticles: (config, vconfig) =>
    requestCommonAPI('customEncryptApiName-1/0nfejby.nbufsjbmtqfdjbm0tqfdjbm0bsujdmf0cbudi0epxompbe',
      'post',
      config,
      vconfig
    )
}
